// 介錯の砲の形の致命 (2026-11-01・答えるページ exec-pass3-1101 の作者の答え fin = A「砲から刃に変形してから執行する」)。
//   前の版 (DEV ?execCannonFin=old): 砲を持ったまま致命の溜めに入り、刃の絵 (据え斬り sue_*) が無いので
//     前の並び (overhead_raise → downswing_smear → exec_contact) で代用していた。11-01 作者「無理やり他のもので代用している」。
//   今の版: 崩れた主人公へ致命を出す時、砲を持っていれば、致命の溜めに入る代わりに組み変わり (砲→刃) をその場で出す。
//     組み変わりは普段のものをそのまま使う (morph_a→b→c の絵・光・音)。ただし突き飛ばしの区間は飛ばす (崩れている主人公を押さない)。
//     組み変わりが終われば刃を持った待機に戻り、崩れを見た待機の流れ (boss.ts) がそのまま刃の「執行」を出す。
//     崩れは致命が当たるか弾かれるまで続く (src/exec_parry.ts) ので、組み変わりの 800ms を挟んでも致命は届く。
//   記録 = docs/research/2026-11-01-exec-answers.md
import type { Boss, Player } from './types'
import { executionerMorphTiming } from './executioner_weapon'

let old = false
export function setExecCannonFinisher(v: string | null): void { old = v === 'old' }
/** 砲の形の致命を、組み変わってから刃の執行で出すか (既定 = 出す・DEV ?execCannonFin=old で前の代用)。 */
export function execCannonFinisherMorph(): boolean { return !old }

/**
 * 介錯が砲を持って致命の溜めに入ったばかりなら、代わりに砲→刃の組み変わりへ置き換える。
 *   突き飛ばしの区間 (shoveEndMs まで) は済んだ扱いにして、組み変わりの絵の頭から始める。向きは主人公へ。
 */
export function cannonFinisherToMorph(prev: Boss, next: Boss, player: Player): Boss {
  if (!execCannonFinisherMorph() || next.id !== 'the-executioner' || !next.exec) return next
  if (next.exec.held !== 'cannon' || next.exec.morph === 'morphing') return next
  if (next.state !== 'telegraph' || next.currentAttack?.id !== 'executioner_finisher') return next
  if (prev.state === 'telegraph' && prev.currentAttack?.id === 'executioner_finisher') return next
  const exec = { ...next.exec, step: null, morph: 'morphing' as const, morphTurnRequired: false }
  return {
    ...next,
    state: 'idle',
    stateElapsed: 0,
    currentAttack: null,
    currentString: null,
    beatIndex: 0,
    facing: player.x < next.x ? 'left' : 'right',
    exec: { ...exec, morphElapsedMs: executionerMorphTiming(exec).shoveEndMs },
  }
}
